const CARDS_PER_PAGE = 16;
const DEFAULT_TYPE = null // Default to all

export default class LeadershipGrid {


	// Constructor
	constructor(asscroll, cursor, element) {

		this.asscroll = asscroll;
		this.asscrollCurrentPos = 0;
		this.asscrollElement = (asscroll) ? asscroll.scrollElements : null;

		this.cursor = cursor;

		this.element = element;
		this.data = JSON.parse(this.element.querySelector('.data').innerHTML);

		// Client wanted to combind services and practice groups with types
		this.data.types = this.data.types.concat(this.data.practicegroups)
		this.data.types = this.data.types.concat(this.data.services)


		this.more = this.element.querySelector('.section-leadership-grid--more');
		this.moreButton = this.more.querySelector('button');
		this.cardsContainer = this.element.querySelector('.section-leadership-grid--cards');
		this.noResults = this.cardsContainer.querySelector('p');

		// this.expertisePrefix = this.element.querySelector('[data-expertise-prefix]')
		// this.expertisePrefixLabel = this.element.querySelector('[data-expertise-label]')

		// this.expertisesButton = this.element.querySelector('.section-leadership-grid--button-expertises');
		// this.expertisesButtonText = this.expertisesButton.querySelector('span');
		// this.expertisesAll = this.expertisesButtonText.innerHTML;
		// this.expertiseId = null;

		this.officesPrefix = this.element.querySelector('[data-offices-prefix]')
		this.officesPrefixLabel = this.element.querySelector('[data-offices-label]')

		this.officesButton = this.element.querySelector('.section-leadership-grid--button-offices');
		this.officesButtonText = this.officesButton.querySelector('span');
		this.officesAll = this.officesButtonText.innerHTML;
		this.officeId = null;

		this.typesPrefix = this.element.querySelector('[data-types-prefix]')
		this.typesPrefixLabel = this.element.querySelector('[data-types-label]')

		this.typesButton = this.element.querySelector('.section-leadership-grid--button-types');
		this.typesButtonText = this.typesButton.querySelector('span');
		this.typesAll = this.typesButtonText.innerHTML;
		this.typeId = null;

		this.panel = document.createElement('div');
		this.panel.className = 'section-leadership-grid--panel';
		this.panel.innerHTML = '<button><span class="screen-reader-text">Close</span></button><div><div><button class="section-leadership-grid--close"><svg class="svg svg-icon-close"><use xlink:href="#icon-close"></use></svg><span class="screen-reader-text">Close</span></button><div></div></div></div>';
		this.panel.setAttribute('aria-hidden', 'true');
		document.body.appendChild(this.panel);
		this.panelCloseButtons = Array.prototype.slice.call(this.panel.querySelectorAll('button'), 0);
		this.panelContent = this.panel.querySelector('div div div div');
		this.panelScroll = this.panel.querySelector('div');

		this.buttonClosePanel = this.buttonClosePanel.bind(this);
		this.buttonMoreClick = this.buttonMoreClick.bind(this);
		// this.buttonExpertisesClick = this.buttonExpertisesClick.bind(this);
		this.buttonOfficesClick = this.buttonOfficesClick.bind(this);
		this.buttonTypesClick = this.buttonTypesClick.bind(this);
		this.hashChanged = this.hashChanged.bind(this);
		this.selectItem = this.selectItem.bind(this);
		this.handlePanelKeyboardNavigation = this.handlePanelKeyboardNavigation.bind(this)

		this.cardCount = 0;
		this.cards = [];

		this.returnFocusElement = null

		this.queryParams = new URLSearchParams(window.location.search)

		this.page = 1
		if (this.queryParams.has('pnum')) {
			this.page = parseInt(this.queryParams.get('pnum'))
		}

		this.hashChanged({
			typeId: DEFAULT_TYPE,
		});
	}


	// Public Methods
	destroy() {
		this.disable();
		delete this.asscroll;
		delete this.asscrollCurrentPos;
		delete this.asscrollElement;
		delete this.cardCount;
		delete this.cards;
		delete this.cardsContainer;
		delete this.cursor;
		delete this.data;
		delete this.element;
		delete this.more;
		delete this.moreButton;
		delete this.noResults;
		delete this.panel;
		delete this.panelCloseButtons;
		delete this.panelContent;
		delete this.panelScroll;
		delete this.expertiseId;
		delete this.expertisesAll;
		delete this.expertisesButton;
		delete this.expertisesButtonText;
		delete this.officeId;
		delete this.officesAll;
		delete this.officesButton;
		delete this.officesButtonText;

		delete this.typesId;
		delete this.typesAll;
		delete this.typesButton;
		delete this.typesButtonText;
	}
	enable() {
		this.disable();
		this.panelCloseButtons[0].addEventListener('click', this.buttonClosePanel);
		this.panelCloseButtons[1].addEventListener('click', this.buttonClosePanel);
		this.moreButton.addEventListener('click', this.buttonMoreClick);
		// this.expertisesButton.addEventListener('click', this.buttonExpertisesClick);
		this.officesButton.addEventListener('click', this.buttonOfficesClick);
		this.typesButton.addEventListener('click', this.buttonTypesClick);
		this.panelContent.addEventListener('click', this.selectItem);
		// window.addEventListener('hashchange', this.hashChanged, false);
	}
	disable() {
		this.panelCloseButtons[0].removeEventListener('click', this.buttonClosePanel);
		this.panelCloseButtons[1].removeEventListener('click', this.buttonClosePanel);
		this.moreButton.removeEventListener('click', this.buttonMoreClick);
		// this.expertisesButton.removeEventListener('click', this.buttonExpertisesClick);
		this.officesButton.removeEventListener('click', this.buttonOfficesClick);
		this.typesButton.removeEventListener('click', this.buttonTypesClick);
		this.panelContent.removeEventListener('click', this.selectItem);
		// window.removeEventListener('hashchange', this.hashChanged, false);
	}


	// Event Handlers
	buttonClosePanel(event) {
		event.preventDefault();
		if (this.asscroll) {
			this.asscroll.disable();
			this.asscroll.currentPos = this.asscrollCurrentPos;
			this.asscroll.enable({ newScrollElements: this.asscrollElement });
		}
		this.panel.classList.remove('show');
		this.panel.setAttribute('aria-hidden', 'true');
	}

	buttonMoreClick(event) {
		event.preventDefault();

		this.page += 1
		this.queryParams.set('pnum', this.page)

		window.history.replaceState({}, '', `${ window.location.pathname }?${ this.queryParams.toString() }`)
		this.isPageUpdate = true

		this.addCards();
	}

	buttonOfficesClick(event) {
		event.preventDefault();

		var html = `<button class="${ this.officeId === null ? 'active' : '' }" data-type="offices" data-id=""><span>${ this.officesAll }</span></button>`

		html += this.data.offices.map((office) => {
			let isActive = this.officeId == office.id
			return `<button class="${ isActive ? 'active' : '' }" data-type="offices" data-id="${ office.id }"><span>${ office.title }</span></button>`
		}).join('')

		this.panelContent.innerHTML = html;

		if (this.asscroll) {
			this.asscrollCurrentPos = this.asscroll.currentPos;
			this.asscroll.disable();
			this.asscroll.enable({ newScrollElements: this.panelScroll, reset: true });
		}

		this.panel.classList.add('show');
		this.panel.setAttribute('aria-hidden', 'false');

		this.focusActive(event.target)
	}

	buttonTypesClick(event) {
		event.preventDefault();

		var html = `<button class="${ this.typeId === null ? 'active' : '' }" data-type="types" data-id=""><span>${ this.typesAll }</span></button>`

		html += this.data.types.map((type) => {
			let isActive = this.typeId == type.id
			return `<button class="${ isActive ? 'active' : '' }" data-type="types" data-id="${ type.id }"><span>${ type.title }</span></button>`
		}).join('')

		this.panelContent.innerHTML = html;

		if (this.asscroll) {
			this.asscrollCurrentPos = this.asscroll.currentPos;
			this.asscroll.disable();
			this.asscroll.enable({ newScrollElements: this.panelScroll, reset: true });
		}

		this.panel.classList.add('show');
		this.panel.setAttribute('aria-hidden', 'false');

		this.focusActive(event.target)
	}

	focusActive(returnFocusElement) {

		this.returnFocusElement = returnFocusElement

		let activeOption = this.panel.querySelector('.active')
		if (activeOption) {
			activeOption.focus()
			this.asscroll.scrollTo(activeOption.getBoundingClientRect().top)
		}

		window.addEventListener('keyup', this.handlePanelKeyboardNavigation)
	}

	returnFocus() {
		if (this.returnFocusElement) {
			this.returnFocusElement.focus()
		}
	}

	handlePanelKeyboardNavigation(e) {

		// User hit escape. Close the panel
		if (e.keyCode == 27) {
			return this.buttonClosePanel(e)
		}

	  let focasables;
	  if (e.key == 'Tab') {
	    focasables = this.panel.querySelectorAll("a, input, select, button");

	    if (focasables) {
	      const firstElem = focasables[0];
	      const lastElem = focasables[(focasables.length - 1)];
	      if (e.target == firstElem && e.shiftKey) {
	        e.preventDefault();
	        lastElem.focus();
	      } else if (e.target == lastElem && !e.shiftKey) {
	        e.preventDefault();
	        firstElem.focus();
	      }
	    }
	  }
	}

	hashChanged(defaults) {

		// Prevent filter updates when just updating the page
		if (this.isPageUpdate === true) {
			this.isPageUpdate = null
			return;
		}

		var i, l;

		var officeId = null;
		var typeId = null;

		var officeName = this.officesAll;
		if (this.queryParams.has('office')) {
			officeId = (this.queryParams.get('office') == '') ? null : parseInt(this.queryParams.get('office'));
			let office = this.data.offices.find((office) => office.id == officeId)
			if (office) {
				officeName = office.title
			}
		}

		var typeName = this.typesAll;
		if (this.queryParams.get('type')) {
			typeId = (this.queryParams.get('type') == '') ? null : parseInt(this.queryParams.get('type'));
			if (typeId) {
				let type = this.data.types.find((type) => type.id == typeId)
				if (type) {
					typeName = type.title
				}
			}
		}

		if (this.queryParams.get('pnum')) {
			this.page = parseInt(this.queryParams.get('pnum')) || 1;
		}

		if (window.location.search == '' && typeof defaults !== 'undefined' && defaults.typeId && !typeId) {
			// Default to executives
			typeId = defaults.typeId;
			typeName = this.data.types.find((type) => type.id == typeId).title
		}
		
		// Update the text before each filter to make it work like a sentence
		this.typesPrefixLabel.innerHTML = (typeId == null) ? this.typesPrefix.dataset.allText : this.typesPrefix.dataset.defaultText
		this.officesPrefixLabel.innerHTML = (officeId == null) ? this.officesPrefix.dataset.allText : this.officesPrefix.dataset.defaultText

		// Update the filter label display
		this.officesButtonText.innerHTML = (officeName || '').match(/\ball/i) ? officeName.toLowerCase() : officeName;
		this.typesButtonText.innerHTML = (typeName || '').match(/\ball/i) ? typeName.toLowerCase() : typeName;

		this.officeId = officeId;
		this.typeId = typeId;
		this.updateCards();
	}

	selectItem(event) {
		event.preventDefault();
		var button = event.target;
		if (button.tagName !== 'BUTTON') {
			button = button.parentNode;
		}
		if (button.tagName === 'BUTTON') {
			var type = button.getAttribute('data-type');
			var id = button.getAttribute('data-id');

			var officeId = (this.officeId !== null) ? this.officeId : '';
			var typeId = (this.typeId !== null) ? this.typeId : '';

			if (type === 'offices') {
				this.queryParams.set('office', id)
			} else if (type === 'types') {
				this.queryParams.set('type', id)
			}

			// Reset the page on filter change
			this.page = 1
			this.queryParams.set('pnum', this.page)

			window.history.replaceState({}, '', `${ window.location.pathname }?${ this.queryParams.toString() }`)
			this.hashChanged()
		}

		this.buttonClosePanel(event);
	}


	// Helpers
	addCards() {

		let limit = CARDS_PER_PAGE * this.page

		// add our cards
		for (var i=this.cardCount, l=limit; i<l; i++) {
			this.cardCount += 1;
			if (i < this.cards.length) {
				this.addCard(this.cards[i]);
			}
		}

		// hide/show more button
		if (this.cardCount >= this.cards.length) {
			this.more.classList.add('hide');
		} else {
			this.more.classList.remove('hide');
		}

		// Trigger window to resize event to fix ASScroll's height issues
		if (this.asscroll) {
			window.dispatchEvent(new Event('resize'));
		}

		// Update our cursor hovers
		if (this.cursor) {
			this.cursor.updateHovers();
		}

	}
	addCard(item) {
		this.cardsContainer.insertAdjacentHTML('beforeend', item.card);
	}
	updateCards() {

		var i, l;

		let filters = [];

		if (this.officeId != null) {
			filters.push({ key: 'offices', value: this.officeId })
		}

		if (this.typeId != null) {
			filters.push({ key: 'types', value: this.typeId })
		}

		var posts = this.data.posts.filter((post) => {

			if (filters.length == 0) {
				return true;
			}

			return filters.every((filter) => post[filter.key].includes(filter.value))
		})

		let sortTypeId = this.typeId || 'all';
		let sortKey = `leadership_sort_${sortTypeId}`

		// Make sure every entry has a sort order. If not, default to sorting alphabetically. 
		let hasDefinedSortOrder = posts.some((post) => typeof post[sortKey] !== 'undefined')

	  	posts.sort((a, b) => {
			// Sort by title (name) if there's no type selected
			if (!hasDefinedSortOrder) {
				return a.last_name == b.last_name ? 0 : a.last_name > b.last_name ? 1 : -1;
			}

			let aVal = parseInt(a[sortKey]);
			let bVal = parseInt(b[sortKey]);

			return aVal - bVal
		});

		this.cardCount = 0;
		this.cards = [];
		this.cardsContainer.innerHTML = '';
		this.more.classList.add('hide');
		if (posts.length === 0) {
			this.cardsContainer.appendChild(this.noResults);
		} else {
			this.cards = posts;
			this.addCards();
		}
	}
}
